import {Ability} from '@casl/ability'
const abilities = JSON.parse(sessionStorage.getItem('abilities') || "[]");
const existingAbility = abilities ? abilities : [];

export default new Ability(existingAbility );